import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import {
    ConfigurationImmediateShelfPriorityAssignmentCreateRequest,
    ConfigurationImmediateShelfPriorityAssignmentPatchInBatchRequest,
    ConfigurationImmediateShelfPriorityAssignmentResponse
} from '@/modules/configurationModule/detail/automation/grossing-shelf/immediate-shelf-priority/services/configuration-immediate-shelf-priority-assignment/configuration-immediate-shelf-priority-assignment.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationImmediateShelfPriorityAssignmentService {
    async create(laboratoryId: number, request: ConfigurationImmediateShelfPriorityAssignmentCreateRequest): Promise<ConfigurationImmediateShelfPriorityAssignmentResponse> {
        const response = await axios.post<ConfigurationImmediateShelfPriorityAssignmentResponse>(`/configuration/laboratories/${laboratoryId}/immediateShelfPriorityAssignment`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationImmediateShelfPriorityAssignmentResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationImmediateShelfPriorityAssignmentResponse>>(`/configuration/laboratories/${laboratoryId}/immediateShelfPriorityAssignment`, { ...filterModel }, { params })
        return response.data
    }

    async get(immediateShelfPriorityAssignmentId: number, laboratoryId: number): Promise<ConfigurationImmediateShelfPriorityAssignmentResponse> {
        const response = await axios.get<ConfigurationImmediateShelfPriorityAssignmentResponse>(`/configuration/laboratories/${laboratoryId}/immediateShelfPriorityAssignment/${immediateShelfPriorityAssignmentId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/immediateShelfPriorityAssignment/batch`, { data: request })
        return response.data
    }

    async patch(laboratoryId: number, request: ConfigurationImmediateShelfPriorityAssignmentPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/immediateShelfPriorityAssignment/batch`, request)
        return response.data
    }
}

export const configurationImmediateShelfPriorityAssignmentService = new ConfigurationImmediateShelfPriorityAssignmentService()
